export type SimpleComponentParameters = {
  type: string;
  key: string;
  label: string;
};
export type DataGridParameters = {
  label: string;
  tooltip: string;
  key: string;
  weight: number;
};
/**
 * Helper function for the creation of dataGrids in the Formbuilder.
 *
 * @param dataGrid the parameters for the dataGrid itself
 * @param componentsArray the array of components that will be shown in each row
 */
export const dataGridHelperComponent = (
  dataGrid: DataGridParameters,
  componentsArray: Array<SimpleComponentParameters>
) => {
  return {
    label: dataGrid.label,
    tooltip: dataGrid.tooltip,
    key: dataGrid.key,
    type: 'datagrid',
    labelPosition: 'top',
    disableAddingRemovingRows: false,
    reorder: false,
    addAnotherPosition: 'bottom',
    layoutFixed: false,
    enableRowGroups: false,
    initEmpty: false,
    hidden: false,
    hideLabel: false,
    autofocus: false,
    disabled: false,
    tableView: false,
    modalEdit: false,
    defaultValue: [{}],
    persistent: true,
    protected: false,
    dbIndex: false,
    encrypted: false,
    clearOnHide: true,
    calculateServer: false,
    allowCalculateOverride: false,
    input: true,
    multiple: false,
    unique: false,
    dataGridLabel: false,
    showCharCount: false,
    showWordCount: false,
    allowMultipleMasks: false,
    tree: true,
    weight: dataGrid.weight,
    components: componentsArray
  };
};
